export const WhyVibeCardData = [
    {
        id: 1,
        title: 'Recognition',
        text: 'Thrive in a culture where your hard work and achievements are celebrated and regularly acknowledged.'
    },
    {
        id: 4,
        title: 'Competitive Pay',
        text: 'Benefit from a compensation package that truly reflects your skills and dedication.'
    },
    {
        id: 5,
        title: 'Comprehensive Benefits',
        text: 'Enjoy a benefits package designed to support your overall well-being.'
    },
    {
        id: 2,
        title: 'Team Commitment',
        text: 'Be part of a team that values collaboration, mutual support, and collective success.'
    },
    {
        id: 3,
        title: 'Global Impact',
        text: 'Make a difference worldwide by supporting clientele that transcends geographical boundaries.'
    },
    {
        id: 7,
        title: 'Aspirations Supported',
        text: 'Advance your career with opportunities for continuous learning, professional development, and unwavering encouragement.'
    }
]